import {
  ViewController,
  NavParams,
  NavController,
  LoadingController,
  AlertController,
  PopoverController,
} from "ionic-angular";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import * as moment from "moment";
import * as ics from "ics";

import { AuthProvider } from './../../providers/auth/auth';
import { JobsProvider } from "./../../providers/jobs/jobs";
import { StaffProvider } from "./../../providers/staff/staff";
import { NotificationsProvider } from "./../../providers/notifications/notifications";
import { TrainingCardsProvider } from "./../../providers/training/training";
import { DistrictsProvider } from './../../providers/districts/districts';

import {
  ITrainingCard,
  ITrainingCardStaff, TrainingCardStatus, TrainingCardApplicationStatus
} from "./../../interfaces/training-cards";
import { IStaffType } from "../../interfaces/staff";
import { IUser } from "./../../interfaces/users";
import { IDistrict } from "./../../interfaces/districts";

@Component({
  selector: 'page-training-card',
  templateUrl: 'training-card.html',
})
export class TrainingCardPage {
  title = 'Training Card Details';

  trainingCard: ITrainingCard;
  trainingCardSubscription: Subscription;
  trainingCardDataLoaded = false;

  currentUser: IUser;
  userSubscription: Subscription;
  hasApplied = false;

  canStartJob = false;
  canEndJob = false;
  canClockIn = false;
  canClockOut = false;
  canCancel = true;
  canApply = true;
  // userJobs: IJobStaff[];

  userTrainingCard: ITrainingCardStaff;
  userTrainingCardSubscription: Subscription;
  userTrainingCardDataLoaded = false;

  trainingCardStaff: ITrainingCardStaff[];
  trainingCardStaffSubscription: Subscription;
  trainingCardStaffDataLoaded = false;
  hasStaff = false;

  staffTypesSubscription: Subscription;
  staffTypes: IStaffType[] = [];

  districtForm: FormGroup;
  districtFormSubmitted = false;

  loader;

  get trainingCardStatus() {
    return TrainingCardStatus;
  }

  get trainingCardApplicationStatus() {
    return TrainingCardApplicationStatus;
  }

  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private http: HttpClient,
    public popoverCtrl: PopoverController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private authProvider: AuthProvider,
    private jobsProvider: JobsProvider,
    private trainingCardProvider: TrainingCardsProvider,
    private districtsProvider: DistrictsProvider,
    private staffProvider: StaffProvider,
    private notificationsProvider: NotificationsProvider
  ) {
    //this.job = this.navParams.data.job;
    this.currentUser = this.navParams.data.user;
    this.createApplicationTypeForm();
  }

  ngOnInit() {
    this.authProvider.getFbUser().then(fbUser => {
      this.userSubscription = this.authProvider
        .getUserByUid(fbUser.uid)
        .subscribe(
          data => {
            this.currentUser = data;
            this.loadTrainingCard(this.navParams.data.item);
            return data;
          },
          err => {
            console.log(err);
          }
        );
    });

    console.log(this.navParams.data.item);

  }

  ngOnDestroy() {
    if (this.userTrainingCardSubscription) {
      this.userTrainingCardSubscription.unsubscribe();
    }
    if (this.trainingCardStaffSubscription) {
      this.trainingCardStaffSubscription.unsubscribe();
    }
    if (this.staffTypesSubscription) {
      this.staffTypesSubscription.unsubscribe();
    }
  }

  createApplicationTypeForm() {
    this.districtForm = this.formBuilder.group({
      district: ["", Validators.compose([Validators.required])],
    });
  }

  loadTrainingCard(trainingCardId: string) {
    this.loader = this.loadingCtrl.create({
      content: "Loading job details...",
    });
    this.loader.present();

    this.trainingCardSubscription = this.trainingCardProvider
      .getTrainingCardDetails(trainingCardId)
      .subscribe(
        (data) => {
          this.trainingCard = data;
          if (this.trainingCard.status === 1) {
            this.canCancel = false;
            this.canApply = false;
          }
          console.log("training card");
          console.log(this.trainingCard);
          this.loadUserTrainingCards();
          this.trainingCardDataLoaded = true;
          return data;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  loadUserTrainingCards() {
    this.userTrainingCardSubscription = this.trainingCardProvider
      .getUserTrainingCards(this.currentUser.uid)
      .subscribe(
        (data) => {
          data.forEach((userTrainingCard) => {
            console.log("--- training card id ---");
            console.log(this.trainingCard);

            console.log("--- user training cards ---");
            console.log(userTrainingCard);

            if (this.trainingCard.id === userTrainingCard.trainingCardId) {
              console.log("user has applied for this job");
              this.hasApplied = true;
              this.userTrainingCard = userTrainingCard;
              this.districtsProvider
                .getDistrictPromise(this.userTrainingCard.district)
                .then((district: IDistrict) => {
                  this.trainingCard.inviteCode = district.inviteCode;
                })
                .catch((err) => {
                  console.log(err);
                });
              console.log(this.userTrainingCard);
            }
          });
          this.userTrainingCardDataLoaded = true;
          console.log("userTrainingCardDataLoaded");
          this.loader.dismiss();
        },
        (err) => {
          console.log(err);
        }
      );
  }

  applyForTraining(id: string) {
    this.districtFormSubmitted = true;

    let loader = this.loadingCtrl.create({
      content: "Saving training application...",
    });
    loader.present();

    let alert = this.alertCtrl.create({
      title: "Application successful!",
      message:
        'Your application has been saved against this training card. This training card can be found in the "My Training Cards" page. You will be sent a notification for any updates to this training card',
      buttons: [
        {
          text: "Ok",
          role: "cancel",
          handler: () => {
            console.log("Ok clicked");
            this.viewCtrl.dismiss();
            this.districtFormSubmitted = true;
          },
        },
      ],
    });

    if (moment().isSameOrAfter(moment(this.trainingCard.end))) {
      let isOverAlert = this.alertCtrl.create({
        title: "Training card is over!",
        message: "You cannot apply for a training card that is already over",
        buttons: [
          {
            text: "Ok",
            role: "cancel",
            handler: () => {
              console.log("Ok clicked");
              this.viewCtrl.dismiss();
              this.districtFormSubmitted = true;
            },
          },
        ],
      });

      loader.dismiss();
      isOverAlert.present();

      return;
    }

    if (this.districtForm.valid) {
      console.log(id);
      const trainingCardStaff: ITrainingCardStaff = {
        trainingCardId: id,
        userId: this.currentUser.uid,
        district: this.districtForm.value.district,
      };
      this.trainingCardProvider
        .createTrainingCardStaff(trainingCardStaff)
        .then(() => {
          //this.navCtrl.setRoot(MyJobsPage);
          loader.dismiss();
          alert.present();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  cancelApplication() {
    //const self = this;
    let alert = this.alertCtrl.create({
      title: "Cancel application",
      message:
        "Are you sure that you would like to cancel for training card application",
      buttons: [
        {
          text: "No",
          role: "cancel",
          handler: () => {
            console.log("Ok clicked");
            this.viewCtrl.dismiss();
          },
        },
        {
          text: "Yes",
          handler: () => {
            console.log("Ok clicked");
            this.trainingCardProvider
              .cancelTrainingCardApplication(
                this.trainingCard.id,
                this.currentUser.uid
              )
              .then(() => {
                this.viewCtrl.dismiss();
              })
              .catch((err) => {
                console.log(err);
              });
          },
        },
      ],
    });
    alert.present();
  }

  openLobsterInk() {
    window.open('https://jbxysa.lobster-access.com/invitation/join', '_blank');
  }

  close() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/training-card/training-card.ts